import { render, staticRenderFns } from "./form-text-area-submitted-preview.vue?vue&type=template&id=b8d0ca9a&scoped=true&"
import script from "./form-text-area-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./form-text-area-submitted-preview.vue?vue&type=script&lang=js&"
import style0 from "./form-text-area-submitted-preview.vue?vue&type=style&index=0&id=b8d0ca9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d0ca9a",
  null
  
)

component.options.__file = "form-text-area-submitted-preview.vue"
export default component.exports